import React from "react";
import { useUser } from "reactfire";
import { classNames } from "utils/utils";
import SkeletonLoader from "components/skeletonLoader";
import {
  ArrowTrendingDownIcon,
  ArrowTrendingUpIcon,
  FireIcon,
} from "@heroicons/react/24/outline";
import { useLeague } from "context/leagueContext";
import LeaderboardInfo from "components/leaderboardInfo";
import { useTranslation } from "react-i18next";

const Leaderboard = ({
  users,
  isLoading,
  settled,
  prizePool,
  roundInfo,
  hideElimintated,
  isRound,
}) => {
  const { status, data: user } = useUser();
  const {
    state: { leagueInfo, nextRoundId },
  } = useLeague();
  const { t } = useTranslation();
  let scoreRule = leagueInfo?.scoreRule;

  const maxScore = users.reduce((acc, val) => {
    return acc > val.points ? acc : val.points;
  }, 0);

  const winners = users.filter(function (item) {
    if (item.points >= maxScore) return item;
  });

  let pointsThreshold = roundInfo?.pointsThreshold;
  let showPointsThreshold =
    leagueInfo?.gameRule === 4 && leagueInfo?.scoreRule === 1;

  let remainingPlayers = leagueInfo?.userCount - leagueInfo?.eliminatedCount;
  const isFinalRound =
    remainingPlayers == 2 ||
    (remainingPlayers == 3 && leagueInfo?.eliminationRate > 33);

  const userList = users?.map((item, id) => {
    let isWinner = winners.find((x) => x.id === item.id) && settled;
    let isLeading = winners.find((x) => x.id === item.id) && maxScore > 0;
    let climbing =
      item.prevPosition && item.pos && item.prevPosition - item.pos > 6;
    let trendUp =
      item.prevPosition && item.pos && item.prevPosition - item.pos > 3;
    let trendDown =
      item.prevPosition && item.pos && item.prevPosition - item.pos < -3;

    //let climbing = item.pos < item.prevPos;
    return (
      <div
        className={classNames(
          showPointsThreshold &&
            item.points <= pointsThreshold &&
            "text-red-500 bg-[#DE564A]/10 ",
          showPointsThreshold &&
            users?.length - 1 == id &&
            "rounded-b-md border-b-2 border-white",
          "flex justify-between py-1  px-2 border-x-2 border-white"
        )}
        key={item.id}
      >
        <div className="flex">
          <div
            className={classNames(
              showPointsThreshold &&
                pointsThreshold != undefined &&
                item.points <= pointsThreshold
                ? " bg-red-500 text-white"
                : "",
              showPointsThreshold &&
                leagueInfo?.gameRule === 4 &&
                item.gameOver &&
                "text-gray-400",
              "flex py-1 rounded-md shrink-0 justify-center items-center text-center px-2 w-8 font-medium whitespace-nowrap mr-2"
            )}
          >
            {id + 1}.
          </div>

          <img
            src={item?.photo}
            className={classNames(
              leagueInfo?.gameRule === 4 && item.gameOver && "opacity-50",
              "rounded-full w-8 h-8"
            )}
            alt=""
          />
          <div className="grid items-center w-full  pl-2">
            <div
              className={classNames(
                leagueInfo?.gameRule === 4 && item.gameOver
                  ? "text-gray-400"
                  : "",
                user.uid == item.id ? "font-bold" : "font-normal",
                "truncate text-black "
              )}
            >
              {item?.userName}
            </div>
          </div>
        </div>
        <div
          className={classNames(
            user.uid == item.id ? "font-bold" : "",
            "flex justify-center items-center  "
          )}
        >
          <span className="mr-2">{isWinner ? "🏆" : ""}</span>
          <span className="mr-2">
            {climbing ? (
              <FireIcon className="h-6 w-6 text-customGreen" />
            ) : trendUp ? (
              <ArrowTrendingUpIcon className="h-6 w-6 text-customGreen" />
            ) : trendDown ? (
              <ArrowTrendingDownIcon className="h-6 w-6 text-red-500" />
            ) : (
              ""
            )}
          </span>
          {prizePool && isLeading && (
            <span className="mr-2">+{prizePool}p</span>
          )}
          <span
            className={classNames(
              scoreRule == 2
                ? "w-16"
                : scoreRule == 4 ||
                  scoreRule == 6 ||
                  scoreRule == 1 ||
                  scoreRule == 8 ||
                  scoreRule == 3
                ? "min-w-[3rem]"
                : scoreRule == 0
                ? "min-w-[2.25rem]"
                : "w-fit",
              "flex justify-center"
            )}
          >
            <div className="flex  bg-gray-200 text-black  py-1 rounded-md justify-center items-center text-center px-2 w-full font-medium whitespace-nowrap">
              {scoreRule == 2
                ? item.points.toFixed(2)
                : scoreRule == 6
                ? item.leaguePicks
                : item.points}
            </div>
          </span>
        </div>
      </div>
    );
  });

  return (
    <div className="flex w-full flex-col space-y-1">
      {leagueInfo?.eliminationRate &&
        isRound &&
        nextRoundId == roundInfo?.id && (
          <LeaderboardInfo
            number={!isFinalRound && leagueInfo?.eliminationRate}
            title={
              isFinalRound
                ? t("tournament.leaderboard.final_round_title")
                : t("tournament.leaderboard.elimination_rate")
            }
            subtitle={
              isFinalRound &&
              t("tournament.leaderboard.final_round_description")
            }
            symbol={!isFinalRound && "%"}
            type={"warning"}
          />
        )}
      <div className="flex flex-col pt-2">
        {isLoading ? (
          <SkeletonLoader type={"userTopList"} amount={3} />
        ) : (
          userList
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
